import { Droplets, Thermometer, Sun, Clock, SprayCan, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import BreadcrumbSchema from '../components/BreadcrumbSchema';

const CARE_TIPS = [
  {
    icon: Droplets,
    title: "Apply on Pulse Points",
    desc: "Spray on wrists, neck, behind ears, and inner elbows. These warm areas help diffuse the scent throughout the day.",
  },
  {
    icon: SprayCan,
    title: "Don't Rub, Let It Dry",
    desc: "Rubbing your wrists together breaks down the fragrance molecules. Just spray and let it air dry naturally.",
  },
  {
    icon: Thermometer,
    title: "Store Properly",
    desc: "Keep your fragrances in a cool, dry place away from direct sunlight and heat. Avoid storing in bathrooms — humidity degrades the scent.",
  },
  {
    icon: Sun,
    title: "Avoid Sun Exposure",
    desc: "Don't leave bottles near windows or in your car. UV light and heat break down the fragrance oils and change the scent.",
  },
  {
    icon: Clock,
    title: "Moisturize First",
    desc: "Apply an unscented moisturizer or petroleum jelly on skin before spraying. Hydrated skin holds fragrance 2-3x longer.",
  },
  {
    icon: ShieldCheck,
    title: "Layer for Longevity",
    desc: "Use matching or complementary scented body wash and lotion before applying your perfume for maximum performance.",
  },
  {
    icon: Clock,
    title: "Nose Fatigue is Normal",
    desc: "Can't smell your perfume after a while? That's nose fatigue — your brain tunes out familiar scents. Others can still smell it. Don't overspray, just trust the process.",
  },
];

export default function AfterCarePage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-8 pb-20" data-testid="after-care-page">
      <SEOHead
        title="Fragrance After Care Guide"
        description="Learn how to apply, store, and care for your luxury EDP (30% oil concentration, Extrait-level) so every JS Fragrance scent lasts longer and smells its best on your skin."
        url="https://jsfragrances.com/after-care"
      />
      <BreadcrumbSchema crumbs={[{ name: 'Home', path: '/' }, { name: 'After Care', path: '/after-care' }]} />
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <p className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-sans mb-3">Fragrance Care</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-light text-white mb-3" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            After Care Guide
          </h1>
          <p className="text-white/40 text-sm font-sans max-w-md mx-auto">
            Get the most out of your JS Fragrance. Follow these tips para mas tumagal at mas maganda ang performance ng scent mo.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {CARE_TIPS.map((tip, idx) => {
            const Icon = tip.icon;
            return (
              <div
                key={idx}
                className="bg-[#141414] border border-white/5 p-5 hover:border-[#D4AF37]/20 transition-colors"
                data-testid={`care-tip-${idx}`}
              >
                <Icon className="w-5 h-5 text-[#D4AF37] mb-3" />
                <h3 className="text-white text-sm font-sans font-medium mb-1.5">{tip.title}</h3>
                <p className="text-white/40 text-xs font-sans leading-relaxed">{tip.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-10 bg-[#141414] border border-[#D4AF37]/10 p-6 text-center">
          <p className="text-white/60 text-sm font-sans mb-1">Need help with your fragrance?</p>
          <p className="text-white/30 text-xs font-sans">
            Message us on our social media or email <span className="text-[#D4AF37]">support@jsfragrances.com</span>
          </p>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/shop"
            className="inline-block bg-[#D4AF37] text-black px-6 py-3 text-sm uppercase tracking-[0.15em] font-medium hover:bg-[#F3E5AB] transition-colors"
            data-testid="browse-shop-btn"
          >
            Browse Our Collection
          </Link>
        </div>
      </div>
    </div>
  );
}
